import styled from '@emotion/styled';

import { inputFocusStyles } from './utils/mixins';
import {
  COLOR_BORDER_INPUT,
  COLOR_SURFACE_INSET,
  COLOR_TEXT_MUTED,
  COLOR_TEXT_PRIMARY,
  RADIUS_MD,
} from './utils/variables';

export type FieldInputProps = {
  disabled?: boolean;
};

export const FieldInput = styled.input<FieldInputProps>`
  width: 100%;
  box-sizing: border-box;
  border: 1px solid ${COLOR_BORDER_INPUT};
  border-radius: ${RADIUS_MD};
  padding: 10px 12px;
  font-size: 14px;
  color: ${COLOR_TEXT_PRIMARY};
  transition:
    border-color 0.15s ease,
    box-shadow 0.15s ease;

  &:focus {
    ${inputFocusStyles}
  }

  &:disabled {
    background: ${COLOR_SURFACE_INSET};
    color: ${COLOR_TEXT_MUTED};
    cursor: not-allowed;
  }
`;
